import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_success_quiz_result = _resolveComponent("success-quiz-result");
  const _component_chapter_wide_screen_msg = _resolveComponent("chapter-wide-screen-msg");
  const _component_standard_button = _resolveComponent("standard-button");
  const _component_quiz_viewer_layout = _resolveComponent("quiz-viewer-layout");
  return _openBlock(), _createBlock(_component_quiz_viewer_layout, {
    "center-content": !_ctx.canEdit
  }, _createSlots({
    content: _withCtx(() => [_ctx.canEdit ? (_openBlock(), _createBlock(_component_success_quiz_result, {
      key: 0,
      "is-author": _ctx.canEdit,
      quizResultPercentage: _ctx.quizResultPercentage,
      minSuccessRate: _ctx.minSuccessRate,
      quizSucceededMsg: _ctx.quizSucceededMsg,
      quizFailedMsg: _ctx.quizFailedMsg
    }, null, 8, ["is-author", "quizResultPercentage", "minSuccessRate", "quizSucceededMsg", "quizFailedMsg"])) : (_openBlock(), _createElementBlock(_Fragment, {
      key: 1
    }, [_ctx.quizExamAccomplished ? (_openBlock(), _createBlock(_component_success_quiz_result, {
      key: 0,
      "is-author": _ctx.canEdit,
      quizResultPercentage: _ctx.quizResultPercentage,
      minSuccessRate: _ctx.minSuccessRate,
      quizSucceededMsg: _ctx.quizSucceededMsg,
      quizFailedMsg: _ctx.quizFailedMsg
    }, null, 8, ["is-author", "quizResultPercentage", "minSuccessRate", "quizSucceededMsg", "quizFailedMsg"])) : (_openBlock(), _createBlock(_component_chapter_wide_screen_msg, {
      key: 1,
      icon: "alert-outline",
      message: _ctx.$t('view.speach.successQuiz.mandatoryQuizzesWarn')
    }, null, 8, ["message"]))], 64))]),
    _: 2
  }, [!_ctx.canEdit ? {
    name: "footer",
    fn: _withCtx(() => [_createVNode(_component_standard_button, {
      label: _ctx.quizExamAccomplished ? _ctx.$t('view.speach.successQuiz.downloadToPDF') : _ctx.$t('view.speach.successQuiz.goToAssessment'),
      onAction: _cache[0] || (_cache[0] = $event => _ctx.onFooterBtnClick())
    }, null, 8, ["label"])]),
    key: "0"
  } : undefined]), 1032, ["center-content"]);
}